// Shared state coordinates for 2D and 3D map navigation
export const stateCoordinates: Record<string, { longitude: number; latitude: number; height: number }> = {
  'AL': { longitude: -86.9023, latitude: 32.8067, height: 700000 },
  'AK': { longitude: -152.4044, latitude: 61.3707, height: 2500000 },
  'AZ': { longitude: -111.4312, latitude: 33.7298, height: 1000000 },
  'AR': { longitude: -92.3731, latitude: 34.9697, height: 700000 },
  'CA': { longitude: -119.4179, latitude: 36.7783, height: 1500000 },
  'CO': { longitude: -105.3111, latitude: 39.0598, height: 1000000 },
  'CT': { longitude: -72.7554, latitude: 41.5978, height: 400000 },
  'DE': { longitude: -75.5071, latitude: 39.3185, height: 300000 },
  'FL': { longitude: -81.5158, latitude: 27.6648, height: 1200000 },
  'GA': { longitude: -83.5007, latitude: 32.1656, height: 800000 },
  'HI': { longitude: -157.4983, latitude: 21.0943, height: 1200000 },
  'ID': { longitude: -114.4788, latitude: 44.2405, height: 1000000 },
  'IL': { longitude: -89.3985, latitude: 40.6331, height: 800000 },
  'IN': { longitude: -86.2816, latitude: 39.8494, height: 700000 },
  'IA': { longitude: -93.2105, latitude: 42.0115, height: 700000 },
  'KS': { longitude: -96.7265, latitude: 38.5266, height: 800000 },
  'KY': { longitude: -84.6701, latitude: 37.6681, height: 700000 },
  'LA': { longitude: -91.8749, latitude: 31.1695, height: 800000 },
  'ME': { longitude: -69.3819, latitude: 44.6939, height: 700000 },
  'MD': { longitude: -76.8021, latitude: 39.0639, height: 500000 },
  'MA': { longitude: -71.5301, latitude: 42.2302, height: 500000 },
  'MI': { longitude: -84.5361, latitude: 44.3148, height: 900000 },
  'MN': { longitude: -93.9196, latitude: 45.6945, height: 1000000 },
  'MS': { longitude: -89.6787, latitude: 32.7416, height: 700000 },
  'MO': { longitude: -92.2896, latitude: 38.4561, height: 800000 },
  'MT': { longitude: -110.4544, latitude: 46.9219, height: 1200000 },
  'NE': { longitude: -99.9018, latitude: 41.1254, height: 800000 },
  'NV': { longitude: -117.0554, latitude: 38.3135, height: 1000000 },
  'NH': { longitude: -71.5639, latitude: 43.4525, height: 500000 },
  'NJ': { longitude: -74.5210, latitude: 40.2989, height: 500000 },
  'NM': { longitude: -106.2371, latitude: 34.8405, height: 1000000 },
  'NY': { longitude: -75.5268, latitude: 43.2994, height: 800000 },
  'NC': { longitude: -79.0193, latitude: 35.7596, height: 800000 },
  'ND': { longitude: -99.7840, latitude: 47.5289, height: 800000 },
  'OH': { longitude: -82.9071, latitude: 40.4173, height: 800000 },
  'OK': { longitude: -96.9289, latitude: 35.5653, height: 900000 },
  'OR': { longitude: -122.0709, latitude: 44.5720, height: 1000000 },
  'PA': { longitude: -77.1945, latitude: 41.2033, height: 800000 },
  'RI': { longitude: -71.5117, latitude: 41.6809, height: 300000 },
  'SC': { longitude: -80.9066, latitude: 33.8569, height: 600000 },
  'SD': { longitude: -99.4388, latitude: 44.2998, height: 800000 },
  'TN': { longitude: -86.6923, latitude: 35.7478, height: 800000 },
  'TX': { longitude: -99.9018, latitude: 31.9686, height: 1500000 },
  'UT': { longitude: -111.8910, latitude: 40.1500, height: 800000 },
  'VT': { longitude: -72.7107, latitude: 44.0459, height: 500000 },
  'VA': { longitude: -78.1690, latitude: 37.7693, height: 800000 },
  'WA': { longitude: -121.4907, latitude: 47.4009, height: 1000000 },
  'WV': { longitude: -80.9545, latitude: 38.4912, height: 600000 },
  'WI': { longitude: -89.6165, latitude: 44.2685, height: 800000 },
  'WY': { longitude: -107.3025, latitude: 42.7559, height: 1000000 },
  'USA': { longitude: -119.565326, latitude: 22.696465, height: 11731730.83 },
};

// Convert Cesium height (meters) to approximate Google Maps zoom level
export function heightToZoom(height: number): number {
  if (height > 10000000) return 3;   // USA view
  if (height > 2000000) return 4;    // Alaska
  if (height > 1200000) return 5;    // Large states
  if (height > 800000) return 6;     // Medium states
  if (height > 500000) return 7;     // Small states
  if (height > 300000) return 8;     // Tiny states (DE, RI)
  if (height > 100000) return 9;     // City view
  if (height > 50000) return 11;     // Close city
  return 13;                          // Neighborhood
}
